import { useDispatch } from "react-redux";
import styled from "styled-components"
import { updatePaketlemeDimensionItem } from "../../../../features/addLoad/addLoadSlice";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .dimension-item{
    display: flex;
    align-items: center;
    gap: 10px;
  }

`

const InputContainer = styled.div`
    width: 112px;
    height: 40px;
    filter: none !important;
    background-color: ${({theme}) => theme.mainBgColor};
    position: relative;

    input{
        width: 100%;
        height: 100%;
        padding: 10px 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-radius: ${({radius}) => radius};
        color: var(--color-dark);
        background-color: ${({theme}) => theme.mainBgColor};
        color: ${({theme}) => theme.mainTextColor};

        &:-webkit-autofill,
        &:-webkit-autofill:hover, 
        &:-webkit-autofill:focus, 
        &:-webkit-autofill:active{
            -webkit-box-shadow: 0 0 0 30px white inset !important;
        }
    }

    input:focus ~ label{
        color: ${({theme}) => theme.mainTextColor};
        transform: translateY(-22px);
    }

    label{
        position: absolute;
        transform: ${({value}) => value && "translateY(-22px)"};
        bottom: 12px;
        left: 20px;
        font-size: 12px;
        font-weight: var(--font-weight-lg);
        pointer-events: none;
        transition:  all .3s ease;
        z-index: 5;
        color: ${({theme, value}) => value ? theme.mainTextColor : theme.secondaryTextColor};
        background-color: ${({theme}) => theme.mainBgColor};
    }

`
const PaketlemeDimension = ({dimension, typeId, paketlemeDataItemId}) => {

  const dispatch = useDispatch()

  return (
    <Container>
      {
        dimension?.map((item, i) => (
          <div className="dimension-item" key={i}>

            {/* //! bu çap input u bidon-varil */}
            {
              (typeId === 5) && 
              <div className="input-grp">
                  <InputContainer value={item.cap} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {cap: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.cap || ""}  name={"text"}/> 
                    <label htmlFor={"text"}>Çap(m3)</label>
                  </InputContainer>
              </div>
            }

            {/* //! bu en input u (palet, kutu, IBC, teneke) */}
            {
              (typeId === 0 || typeId === 1 || typeId === 2  || typeId === 6 || typeId === 7) && 
              <div className="input-grp">
                  <InputContainer value={item.en} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {en: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.en || ""} name={"text"}/> 
                    <label htmlFor={"text"}>En(cm)</label>
                  </InputContainer>
              </div>
            }

            {/* //! bu boy input u (palet, kutu,  IBC) */}
            {
              (typeId === 0 || typeId === 1 || typeId === 2 || typeId === 6 || typeId === 7 ) && 
              <div className="input-grp">
                  <InputContainer value={item.boy} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {boy: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.boy || ""} name={"text"}/> 
                    <label htmlFor={"text"}>Boy(cm)</label>
                  </InputContainer>
              </div>
            }

            {/* //! bu yukseklik input u (palet, kutu, varil-bidon, IBC || typeId === 6) */}
            {
              (typeId === 0 || typeId === 1 || typeId === 2 || typeId === 5 || typeId === 6 || typeId === 7) && 
              <div className="input-grp">
                  <InputContainer value={item.yukseklik} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {yukseklik: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.yukseklik || ""} name={"text"}/> 
                    <label htmlFor={"text"}>Yükseklik(cm)</label>
                  </InputContainer>
              </div>
            }

            {/* //! bu ağırlık input u (galiba hepsi) */}
            {
              (typeId === 1 || typeId === 2 || typeId === 3 || typeId === 4 || typeId === 5 || typeId === 6 || typeId === 7 || typeId === 0) && 
              <div className="input-grp">
                  <InputContainer value={item.agirlik} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {agirlik: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.agirlik || ""} name={"text"}/> 
                    <label htmlFor={"text"}>Ağırlık(Kg)</label>
                  </InputContainer>
              </div>
            }

            {/* //! bu sayı input u (palet, kutu, IBC) */}
            {
              (typeId === 1 || typeId === 2 || typeId === 4 || typeId === 5 || typeId === 6 || typeId === 7 || typeId === 0) && 
              <div className="input-grp">
                  <InputContainer value={item.sayisi} radius={"5px"}>
                    <input type="text" id={"text"} onChange={(e)=> dispatch(updatePaketlemeDimensionItem({id: paketlemeDataItemId, dimensionId: item.id, updatedData: {sayisi: e.target.value.replace(/[^0-9]/g, '')}}))} value={item?.sayisi || ""} name={"text"}/> 
                    <label htmlFor={"text"}>Sayısı(Adet)</label>
                  </InputContainer>
              </div>
            }

          </div>
        ))
      }

    </Container>
  )
}

export default PaketlemeDimension